import { HomeSlideRepository } from '../../domain/repositories/home-slide.repository';

export class DeleteHomeSlideUseCase {
  constructor(private readonly homeSlideRepository: HomeSlideRepository) {}

  public async execute(id: string): Promise<void> {
    return this.homeSlideRepository.deleteSlide(id);
  }
}
